module.exports = __webpack_public_path__ + "fonts/silk_serif_bold-webfont.46a5ed9.ttf";